import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import notify from '../../utils/IANotification';
import FileUploadField from '../../components/FileUploadField';
import Select from 'react-select'
import { MdDelete, MdArrowBack, MdSave, MdDragIndicator } from 'react-icons/md';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';

export default function BulletinFormPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")

  let bulletin_id = new URLSearchParams(window.location.search).get("bulletin_id")

  const [bulletinData, setBulletinData] = useState({
    title: "",
    remarks: "",
    media_asset_id: "",
    announcements: [],
  })
  const [announcementData, setAnnouncementData] = useState([])
  const [draggingIndex, setDraggingIndex] = useState(null)

  useEffect(() => {
    const fetchBulletinById = async () => {
      if (!bulletin_id || bulletin_id === "new") return
      let endpoint = `${config.endpoint}/bulletin/id/${bulletin_id}`
      let response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      })
      let data = await response.json()
      if (data.status === 200) {
        setBulletinData(data.data)
      } else {
        notify({ type: "error", message: data.message })
      }
    }

    const fetchAnnouncements = async () => {
      let endpoint = `${config.endpoint}/announcements/admin`
      let response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      })
      let data = await response.json()
      if (data.status === 200) {
        setAnnouncementData(data.data)
      } else {
        notify({ type: "error", message: data.message })
      }
    }

    fetchBulletinById()
    fetchAnnouncements()
  }, [bulletin_id])


  const createBulletin = async () => {
    let endpoint = `${config.endpoint}/bulletin/`
    let response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        ...bulletinData,
      }),
    })
    let data = await response.json()
    if (data.status === 200) {
      notify({ type: "success", message: data.message })
      navigate("/admin/bulletin/details?bulletin_id=" + data.data.id)
    } else {
      notify({ type: "error", message: data.message })
    }
  }

  const updateBulletin = async () => {
    if (!bulletin_id || bulletin_id === "new") return
    let endpoint = `${config.endpoint}/bulletin/id/${bulletin_id}`
    let response = await fetch(endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        ...bulletinData,
      }),
    })
    let data = await response.json()
    if (data.status === 200) {
      notify({ type: "success", message: data.message })
    } else {
      notify({ type: "error", message: data.message })
    }
  }

  const deleteBulletin = async () => {
    if (!bulletin_id || bulletin_id === "new") return
    let endpoint = `${config.endpoint}/bulletin/id/${bulletin_id}`
    let response = await fetch(endpoint, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await response.json()
    if (data.status === 200) {
      notify({ type: "success", message: data.message })
      navigate("/admin/bulletin")
    } else {
      notify({ type: "error", message: data.message })
    }
  }

  return (
    <AdminLayout
      navSelected={"Bulletin"}
      headerText={bulletin_id === "new" ? "New Bulletin" : "Edit Bulletin"}
      toolbar={
        <>
          <div className="flex items-center gap-3">
            <Button variant="outline" icon={MdArrowBack} onClick={() => navigate('/admin/bulletin')}>
              Back
            </Button>
            <h1 className='text-xl font-bold text-gray-900'>
              {bulletin_id === "new" ? "Create Bulletin" : bulletinData.title || "Edit Bulletin"}
            </h1>
          </div>
          <div className="flex items-center gap-3">
            {bulletin_id !== "new" && (
              <Button variant="danger" icon={MdDelete} onClick={deleteBulletin}>
                Delete
              </Button>
            )}
            <Button variant="primary" icon={MdSave} onClick={() => {
              if (bulletin_id === "new") createBulletin()
              else updateBulletin()
            }}>
              {bulletin_id === "new" ? "Create" : "Save Changes"}
            </Button>
          </div>
        </>
      }
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <Card title="Bulletin Details" subtitle="Configure bulletin title, header banner, and internal notes.">
            <div className="space-y-6">
              {bulletin_id !== "new" && (
                <div className="input-container">
                  <label className="input-label font-semibold">Bulletin Header Banner</label>
                  <FileUploadField
                    text={"Upload Header"}
                    subtext={"Upload a header image for the bulletin cover"}
                    max_file_size={5}
                    max_files={1}
                    upload_url={`${config.endpoint}/file/bulletin/id/${bulletin_id}`}
                    onChange={() => { }}
                  />
                </div>
              )}

              <div className="input-container">
                <label className="input-label font-semibold">Bulletin Title</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder='e.g. 24 Mar 24 Sunday Bulletin (Internal)'
                  value={bulletinData?.title || ""}
                  onChange={(e) => setBulletinData({ ...bulletinData, title: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Internal Remarks &amp; Notes</label>
                <textarea
                  className="textarea-input h-32"
                  value={bulletinData?.remarks || ""}
                  placeholder='e.g. Internal distribution notes...'
                  onChange={(e) => setBulletinData({ ...bulletinData, remarks: e.target.value })}
                />
              </div>
            </div>
          </Card>
        </div>

        {bulletin_id !== "new" && (
          <div className="lg:col-span-1 space-y-6">
            <Card title="Add Announcement" subtitle="Select announcements to attach to this bulletin.">
              <div className="input-container">
                <label className="input-label font-semibold">Select Announcement</label>
                <Select
                  placeholder="Choose announcement..."
                  options={announcementData.map((announcement) => ({
                    value: announcement.id,
                    label: announcement.title
                  }))}
                  onChange={(selected) => {
                    if (!selected) return
                    if (bulletinData?.announcements?.includes(selected.value)) return
                    setBulletinData({ ...bulletinData, announcements: [...bulletinData.announcements, selected.value] })
                  }}
                />
              </div>
            </Card>

            <Card title="Ordered Announcements" subtitle="Drag to reorder announcements in bulletin sequence.">
              {bulletinData?.announcements?.length > 0 ? (
                <div className="space-y-3">
                  {bulletinData?.announcements.map((announcement_id, index) => {
                    let announcement = announcementData.find((a) => a.id === announcement_id)
                    return (
                      <div
                        key={index}
                        draggable={true}
                        onDragStart={(e) => {
                          e.dataTransfer.effectAllowed = 'move'
                          try { e.dataTransfer.setData('text/plain', String(index)) } catch (err) {}
                          setDraggingIndex(index)
                        }}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                          e.preventDefault()
                          const fromIndexRaw = e.dataTransfer.getData('text/plain')
                          const fromIndex = fromIndexRaw !== '' ? parseInt(fromIndexRaw, 10) : draggingIndex
                          const toIndex = index
                          if (fromIndex === undefined || fromIndex === null || isNaN(fromIndex)) return
                          if (fromIndex === toIndex) {
                            setDraggingIndex(null)
                            return
                          }
                          const newAnnouncements = [...bulletinData.announcements]
                          const [moved] = newAnnouncements.splice(fromIndex, 1)
                          newAnnouncements.splice(toIndex, 0, moved)
                          setBulletinData({ ...bulletinData, announcements: newAnnouncements })
                          setDraggingIndex(null)
                        }}
                        onDragEnd={() => setDraggingIndex(null)}
                        className={`p-3.5 bg-gray-50 rounded-xl border border-gray-200 flex flex-col gap-2 ${
                          draggingIndex === index ? 'opacity-50' : 'opacity-100'
                        }`}
                      >
                        <div className="flex items-center justify-between gap-2">
                          <div className="flex items-center gap-2">
                            <MdDragIndicator className="text-gray-400 cursor-grab" size={18} />
                            <span className="font-bold text-xs text-gray-900 truncate">
                              {announcement?.title || `Announcement #${announcement_id}`}
                            </span>
                          </div>
                          <Button
                            variant="danger"
                            size="sm"
                            icon={MdDelete}
                            onClick={() => {
                              let new_announcements = bulletinData.announcements.filter((id) => id !== announcement_id)
                              setBulletinData({ ...bulletinData, announcements: new_announcements })
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                        {announcement?.file_data?.ext_file_path && (
                          <img
                            src={`${config.endpoint}${announcement.file_data.ext_file_path}`}
                            alt=""
                            className="w-full h-28 object-cover rounded-lg border border-gray-200"
                          />
                        )}
                      </div>
                    )
                  })}
                </div>
              ) : (
                <p className="text-xs text-gray-400 italic">No announcements added yet. Select an announcement above.</p>
              )}
            </Card>
          </div>
        )}
      </div>
    </AdminLayout>
  )
}
